<template>
    <div class="c-app">
        <div class="container">
            <div class="d-flex title-option mt-2">
                <div class="btn-home mt-2 ms-auto">
                    <button type="button" class="btn btn-outline-main" @click="returnHome()">
                        <i class="fas fa-home-lg-alt"></i> Inicio
                    </button>
                </div>
            </div>
            
            <div class="h-100 d-flex align-items-center">
                <div class="w-100" v-if="subpage == 'buttons'">
                    <div class="d-lg-flex justify-content-center gap-2 mt-2">
                        <!-- <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 mb-4">
                            <div class="card card-home-cirujano shadow" @click="mtdShowBook('permiso_caja')">
                                <h4>PERMISOS DE CAJA</h4>
                                <div class="icon-book">
                                    <img class="img-fluid-bed-sop rounded-start" src="../../../assets/gerencia/permiso_caja.png" alt="" />
                                </div>
                            </div>
                        </div> -->
                        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 mb-4">
                            <div class="card card-home-cirujano shadow" @click="mtdShowBook('permiso_anulacion')">
                                <h4>PERMISOS DE ANULACIÓN</h4>
                                <div class="icon-book">
                                    <img class="img-fluid-bed rounded-start" src="../../../assets/gerencia/permiso_anulacion.png" alt="" />
                                </div>
                            </div>
                        </div>
                        <!-- <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 mb-4">
                            <div class="card card-home-cirujano shadow" @click="mtdShowBook('consultas')">
                                <h4>CONSULTAR DOCUMENTO</h4>
                                <div class="icon-book">
                                    <img class="img-fluid-bed-sop rounded-start" src="../../../assets/gerencia/consultar_doc.png" alt="" />
                                </div>
                            </div>
                        </div> -->
                        <!-- <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 mb-4">
                            <div class="card card-home-cirujano shadow" @click="mtdShowBook('note')">
                                <h4>NOTAS DE INGRESO</h4>
                                <div class="icon-book">
                                    <img class="img-fluid-bed rounded-start" src="../../../assets/gerencia/permiso_anulacion.png" alt="" />
                                </div>
                            </div>
                        </div> -->
                    </div>
                    <div class="d-lg-flex justify-content-center gap-2 mt-2">
                        <!-- <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 mb-4">
                            <div class="card card-home-cirujano shadow" @click="mtdShowBook('permiso_os')">
                                <h4>PERMISO DE LOGISTICA</h4>
                                <div class="icon-book">
                                    <img class="img-fluid-bed-sop rounded-start" src="../../../assets/gerencia/permiso_logis.png" alt="" />
                                </div>
                            </div>
                        </div> -->
                       
                        <!-- <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 mb-4">
                            <div class="card card-home-cirujano shadow" @click="mtdShowBook('per_caja_fuerte')">
                                <h4>AUT. CIERRE CAJA FUERTE</h4>
                                <div class="icon-book">
                                    <img class="img-fluid-bed-sop rounded-start" src="../../../assets/gerencia/consultar_doc.png" alt="" />
                                </div>
                            </div>
                        </div> -->
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

    
<script>
import {
    mapActions
} from 'vuex';

export default {
    name: 'c-admision-footerCaja',
    data() {
        return {
            subpage: "buttons",
        }
    },
    methods: {
        ...mapActions(['get', 'post']),

        mtdShowBook(subpage) {
            this.$emit('mtdChangePage', subpage);
        },
        returnHome() {
            this.$emit('mtdChangePage', 'home');
        },

    }

}
</script>
